module.exports = __webpack_public_path__ + "img/1716361167528-WhatsApp Image 2024-05-22 at 13.57.03.jpeg.b93a6df9.webp";